import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AlertLogLevel } from '@app/shared/models/alert-log.model';
import { Color } from '@app/shared/models/color.model';
import { SettingsService } from '@app/components/settings/settings.service';
import { InvoicesSummary } from '@app/shared/interfaces/invoice.interface';
import { AlertService } from '@app/shared/components/organisms/alert/alert.service';

@Component({
  selector: 'app-treshold-notification',
  templateUrl: './treshold-notification.component.html',
  styleUrl: './treshold-notification.component.scss',
  standalone: false,
})
export class TresholdNotificationComponent implements OnInit, OnChanges {
  protected readonly Color = Color;
  protected readonly alertLogLevel = AlertLogLevel;

  tresholdSaved: number = 0;
  invoicesLess: number | undefined = 0;

  @Input() invoicesSummary: InvoicesSummary | undefined;
  @Input() loading: boolean = false;
  @Input() error: boolean = false;

  constructor(
    private settingsService: SettingsService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.settingsService.getSettings().subscribe({
      next: (response) => {
        this.tresholdSaved = response.threshold ?? 0;
      },
      error: () => {
        this.alertService.error('Une erreur est survenue.');
      },
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['invoicesSummary'] && this.invoicesSummary) {
      this.invoicesLess = this.invoicesSummary.invoicesBelowThreshold;
    }
  }
}
